import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaComponent,
  RECAPTCHA_SETTINGS,
} from 'ng-recaptcha';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HarpCommonModule } from '@shared/shared.module';

import { RegistrationRoutingModule } from './register-routes.module';
import { ProfileInfoComponent } from './components/profile-info/profile-info.component';
import { LayoutComponent } from './components/layout/layout.component';
import { AccountInfoComponent } from './components/account-info/account-info.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { WorkflowComponent } from './components/workflow/workflow.component';
import { TermsAndConditionsComponent } from './components/profile-info/terms-and-conditions/terms-and-conditions.component';
import { InitiateManualProofingComponent } from './components/profile-info/initiate-manual-proofing/initiate-manual-proofing.component';

import { RegistrationService } from './services/registration.service';
import { ExperianProofingService } from './services/experian-proofing.service';
import { UserIdentityVerifyService } from './services/user-identity-verify.service';
import { HttpClientModule } from '@angular/common/http';

import { APIClientService } from '@registration/services/api-client.service';
import { WorkflowService } from './components/routeGuard/workflow.service';
import { WorkflowGuard } from './components/routeGuard/workflow-guard.service';
import { NgxMaskModule } from 'ngx-mask';
import { SaviyntService } from './services/savynt-unq-chk.service';
import { UserProofingService } from './services/user-proofing.service';
import { RidpFailedMsgComponent } from './components/remote-proofing/ridp-failed-msg/ridp-failed-msg.component';

import { NavigationService as GlobalNavService } from '@shared/services/navigation.service';
import { APP_CONFIG } from './resources/config';

// @ts-ignore
import configs from '../../../configs/config.json';
import { CaptchaConfigService } from './services/captcha-config.service';

@NgModule({
  declarations: [
    ProfileInfoComponent,
    LayoutComponent,
    AccountInfoComponent,
    ConfirmationComponent,
    WorkflowComponent,
    TermsAndConditionsComponent,
    InitiateManualProofingComponent,
    RidpFailedMsgComponent,
  ],
  imports: [
    NgxMaskModule.forRoot(),
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RegistrationRoutingModule,
    NgbModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    HarpCommonModule,
  ],
  providers: [
    APIClientService,
    RegistrationService,
    UserProofingService,
    WorkflowService,
    SaviyntService,
    WorkflowGuard,
    UserIdentityVerifyService,
    ExperianProofingService,
    GlobalNavService,
    [
      {
        provide: APP_CONFIG,
        useValue: configs,
      },
      {
        provide: RECAPTCHA_SETTINGS,
        useFactory: (configService: CaptchaConfigService) => {
          return configService.config$;
        },
        deps: [CaptchaConfigService],
      },
    ],
  ],
})
export class RegistrationModule {
  constructor(private configService: CaptchaConfigService) {
    this.configService.loadConfig();
  }
}

RecaptchaComponent.prototype.ngOnDestroy = function () {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
};
